import { exists } from '@/api'

export interface HistoryCount {
  year: string
  count: number
}

export function HistoryCountFromJSON(json: any): HistoryCount {
  return {
    year: exists(json, 'year') ? json.year : '',
    count: exists(json, 'count') ? json.count : 0
  }
}

export interface RequestReserveHistoryCount {
  year: string
  count: number
  price: number
}

export function RequestReserveHistoryCountFromJSON(
  json: any
): RequestReserveHistoryCount {
  return {
    year: exists(json, 'year') ? json.year : '',
    count: exists(json, 'count') ? json.count : 0,
    price: exists(json, 'price') ? json.price : 0
  }
}
